import { EUnitOfMeasure } from 'consts/newReservationTypes/serviceConstants';

export const calculatedAmountForServiceTable = (
  unitOfMeasureId: number,
  numberOfGuestsSum: number,
  numberOfDays: number,
) => {
  let calculatedTotalAmount = 0;
  switch (unitOfMeasureId) {
    case EUnitOfMeasure.OSOBA: {
      // Osoba
      calculatedTotalAmount = numberOfGuestsSum;
      break;
    }
    case EUnitOfMeasure.NOC: {
      // noć
      calculatedTotalAmount = numberOfDays;
      break;
    }
    case EUnitOfMeasure.OSOBA_NOC: {
      // osoba/noć
      calculatedTotalAmount = numberOfDays * numberOfGuestsSum;
      break;
    }
    case EUnitOfMeasure.OSOBA_TJEDAN: {
      // osoba/tjedan
      calculatedTotalAmount = (numberOfDays / 7) * numberOfGuestsSum;
      break;
    }
    case EUnitOfMeasure.REZERVACIJA: {
      // rezervacija
      calculatedTotalAmount = 1;
      break;
    }
    case EUnitOfMeasure.TJEDAN: {
      // tjedan
      calculatedTotalAmount = numberOfDays / 7;
      break;
    }
    case EUnitOfMeasure.PO_SATU: {
      // po satu
      calculatedTotalAmount = numberOfDays * 24;
      break;
    }
  }

  return calculatedTotalAmount;
};
